export const ASIDE_HEADER_LOGO_ICON_SIZE = 32;
